<template>
  <div :class="componentClasses">
    <slot />
  </div>
</template>

<script setup>
import { computed } from 'vue';

const componentClasses = computed(() => ['stk-level']);
</script>


<style>
.stk-level {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>
